import { createCollectionHandleKeyMap } from 'config/collections/utils/create-collection-handle-key-map';
import { Region } from 'constants/shop';
import { CollectionFilterConfig, FilterConfig } from '/interfaces/collection-filter';

export const ALL_AVAILABLE_FILTERS: FilterConfig = {
  'nutritional-needs': {
    tags: [
      'sehr-wahlerisch',
      'verdauungsprobleme',
      'unvertraglichkeiten-allergien',
      'haut-and-fellprobleme',
      'pickyeatercat',
      'digestioncat',
      'overweightcat',
      'ubergewicht',
      'intolerancecat',
      'skinfurcat',
      'immunitycat',
      'hairballcat',
    ],
    compare: 'AND',
  },
  'feed-type': {
    tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
  },
  sorts: {
    tags: [
      'huhn',
      'rind',
      'ente',
      'pute',
      'kalb',
      'wild',
      'lachs',
      'pferd',
      'lamm',
      'vegan',
      'ziege',
      'kanguru',
      'hirsch',
      'thunfisch',
      'forelle',
      'wasserbuffel',
      'kaninchen',
      'straus',
      'geflugel',
      'truthahn',
      'bowls-and-similars',
      'toys',
      'walking',
      'sleeping',
      'other-accessories',
    ],
  },
  desires: {
    tags: [
      'getreidefrei',
      'glutenfrei',
      'hypoallergen',
      'monoprotein',
      'low-energy',
      'high-energy',
      'spezielle-erkrankungen',
    ],
    compare: 'AND',
  },
  age: {
    tags: ['welpe', 'adult', 'senior', 'kitten'],
  },
  sizes: {
    tags: ['klein'],
  },
  line: {
    tags: [
      'classic',
      'sensitiv',
      'mini',
      'green',
      'extra-meat',
      'limited',
      'superfood',
      'kaltgepresst',
      'softies',
      'happchen',
      'pasteten',
      'kausnacks',
      'pure-meat',
      'feinschmecker-pate',
      'saucen-menu',
      'genieser-filets',
      'filet-menu',
      'akzeptanz',
      'creme-snack',
      'soft-snacks',
      'filet-snack',
      'suppe',
      'gefriergetrocknet',
    ],
  },
  funktion: {
    tags: [
      'gelenk',
      'haut-and-fell',
      'zeckensaison',
      'denta',
      'entspannung',
      'leber',
      'verdauung',
      'erkaltung',
      'digestion',
      'busy',
      'smart-accessories',
    ],
  },
  'snack-type': {
    tags: [
      'knochen-and-kaurollen',
      'trainingssnacks',
      'zahnpflege',
      'functional-snacks',
      'pasten-and-cremesnacks',
      'hundekekse',
      'kaustreifen-and-sticks',
      'toppers',
      'creme-snack',
      'filet-snack',
      'suppe',
      'soft-snacks',
      'sensitiv',
      'pasten',
      'knuspersnacks',
      'zahnpflege-and-kausnacks',
      'pasten-and-softsnacks',
    ],
  },
  'hero-filter': {
    tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
  },
  'health-needs': {
    tags: [
      'gelenk',
      'haut-and-fell',
      'zeckensaison',
      'denta',
      'entspannung',
      'leber',
      'verdauung',
      'erkaltung',
      'ungeziefer',
    ],
  },
};

/**
 * Config to define filter for each collection.
 */
const FILTER_CONFIG: CollectionFilterConfig = {
  dogsWetFood: { desires: { tags: ['hypocare'] } },
  dogsBarf: { desires: { tags: ['hypocare'] } },
  dogsDryFood: {
    line: {
      tags: ['soft', 'classic', 'green', 'superfood', 'junior', 'hypocare'],
    },
    desires: {
      tags: ['hypocare'],
    },
  },
  dogsPuppyJunior: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind', 'lachs', 'lamm', 'ente', 'pferd', 'wasserbuffel', 'kanguru'],
    },
  },
  dogsSkinCoat: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind-and-kalb', 'fisch', 'pferd', 'ziege'],
    },
  },
  dogsDigestion: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'fisch', 'pferd', 'ziege', 'vegetarisch-vegan'],
    },
  },
  dogsIntolerances: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'wild', 'pferd', 'ziege', 'kanguru', 'insekten', 'vegetarisch-vegan'],
    },
  },
  dogsPickyEater: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind-and-kalb', 'lamm', 'schwein'],
    },
  },
  dogsOverweight: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind-and-kalb', 'fisch', 'insekten'],
    },
  },
  dogsAllMeatTypes: {
    sorts: {
      tags: [
        'geflugel',
        'rind-and-kalb',
        'wild',
        'fisch',
        'lamm',
        'pferd',
        'ziege',
        'kanguru',
        'insekten',
        'vegetarisch-vegan',
        'wasserbuffel',
        'schwein',
      ],
    },
    'nutritional-needs': {
      tags: [
        'sehr-wahlerisch',
        'verdauungsprobleme',
        'unvertraglichkeiten-allergien',
        'haut-and-fellprobleme',
      ],
    },
    age: {
      tags: ['welpe', 'adult-1-6-jahre', 'senior-7-jahre'],
    },
    'hero-filter': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
  },
  catsWetFood: {
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    desires: {
      tags: ['hypocare'],
    },
  },
  dogsChihuahua: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'geflugel', 'lamm'],
    },
  },
  dogsSpitz: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'fisch', 'geflugel'],
    },
  },
  dogsShepherd: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'fisch', 'geflugel', 'insekten'],
    },
  },
  dogsBulldog: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['pferd', 'ziege', 'kanguru', 'wild', 'geflugel', 'fisch', 'insekten'],
    },
  },
  dogsMixedBreed: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'geflugel', 'wild'],
    },
  },
  dogsRetriever: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'lamm', 'rind-and-kalb', 'fisch', 'insekten'],
    },
  },
  dogsTerrier: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'wild', 'fisch', 'geflugel', 'lamm'],
    },
  },
  dogsPoodle: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['rind-and-kalb', 'fisch', 'geflugel', 'pferd', 'lamm', 'wild'],
    },
  },
  dogsMaltese: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind-and-kalb', 'lamm'],
    },
  },
  dogsDachshund: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'lamm', 'rind-and-kalb', 'fisch', 'insekten'],
    },
  },
  dogsHerdingDogs: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    sorts: {
      tags: ['geflugel', 'rind-and-kalb', 'wild', 'fisch', 'lamm'],
    },
  },
  catsAllMeatTypes: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    'nutritional-needs': {
      tags: ['pickyeatercat', 'digestioncat', 'overweightcat'],
    },
    age: {
      tags: ['kitten', 'adult', 'senior'],
    },
    sorts: {
      tags: [
        'huhn',
        'rind',
        'ente',
        'pute',
        'kalb',
        'wild',
        'lachs',
        'thunfisch',
        'kanguru',
        'kaninchen',
      ],
    },
  },
  catsPickyEater: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: ['huhn', 'wild', 'thunfisch', 'pute', 'lachs', 'geflugel', 'rind'],
    },
  },
  catsDigestion: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: ['huhn', 'pute', 'kanguru', 'lachs', 'thunfisch', 'ente', 'rind'],
    },
  },
  catsOverweight: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: ['huhn', 'pute', 'lachs', 'thunfisch', 'ente', 'rind'],
    },
  },
  catsKitten: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: ['lachs', 'huhn', 'rind', 'pute', 'kalb'],
    },
  },
  catsSenior: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: ['pute', 'ente', 'huhn', 'kanguru', 'rind', 'truthahn', 'lachs', 'thunfisch', 'kalb'],
    },
  },
  dogsSenior: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
    sorts: {
      tags: [
        'geflugel',
        'rind-and-kalb',
        'wild',
        'fisch',
        'lamm',
        'pferd',
        'kanguru',
        'kaninchen',
        'straus',
        'insekten',
        'vegetarisch-vegan',
        'schwein',
      ],
    },
  },
  dogsAdult: {
    sorts: {
      tags: [
        'geflugel',
        'rind-and-kalb',
        'wild',
        'fisch',
        'lamm',
        'pferd',
        'ziege',
        'kanguru',
        'wasserbuffel',
        'insekten',
        'vegetarisch-vegan',
      ],
    },
    'hero-filter': {
      tags: ['nassfutter', 'trockenfutter', 'barf', 'snacks'],
    },
  },
  dogsAllProducts: {
    ...ALL_AVAILABLE_FILTERS,
  },
  catsAllProducts: {
    ...ALL_AVAILABLE_FILTERS,
  },
  catsAdult: {
    'feed-type': {
      tags: ['nassfutter', 'trockenfutter', 'snacks'],
    },
    line: {
      tags: [
        'saucen-menu',
        'pasteten',
        'mousse',
        'filet-menu',
        'silkycream',
        'juicyfilets',
        'puremeat',
        'meatypate',
        'vet',
        'limited',
      ],
    },
    sorts: {
      tags: [
        'huhn',
        'rind',
        'ente',
        'pute',
        'kalb',
        'wild',
        'lachs',
        'thunfisch',
        'kanguru',
        'kaninchen',
      ],
    },
  },
};

export const getFilterConfigByHandle = (
  handle: string,
  region: Region = Region.DE
): FilterConfig | undefined => {
  const key = createCollectionHandleKeyMap(handle, region);

  return key ? FILTER_CONFIG[key] : undefined;
};

export default FILTER_CONFIG;
